module.exports = __webpack_public_path__ + "img/product7ap.0bdab585.png";